import { Collection } from 'modules/core/lib/mobx-rest'

import AllowanceIncidence from 'modules/timeoff/store/models/AllowanceIncidence'

class AllowanceIncidences extends Collection<AllowanceIncidence> {
  get cacheKey(): string {
    return 'allowanceIncidences'
  }

  model() {
    return AllowanceIncidence
  }
}

const singleton: AllowanceIncidences = new AllowanceIncidences()
export default singleton
